export const API_URL = "https://user.corevisualizers.com/api/";
export const FILE_API_URL = "https://user.corevisualizers.com/api";
